export const HELMET_BLACK_DRIVER_JAMES_HUNT = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

        
      


    
    {/*Background Black*/}
    <path 
        fill="rgb(90,90,90)" 
        d="M295.31,140.592c15.959,0,28.52,9.59,31.176,23.92l3.755,20.187 c4.622,1.241,1.783,8.212,0.386,11.543l-2.126,5.008c-0.975,2.013-2.859,5.337-4.996,5.281l-6.514-0.342 c-3.291-0.191-6.769-0.616-10.016-1.176l-39.141-6.901c-2.97-7.738-5.789-16.426-5.789-26.26	C262.045,152.664,276.121,140.592,295.31,140.592L295.31,140.592z"
    />
    {/*Base Color*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M263.274,171.851c0-11.66,8.771-29.603,32.034-29.603 c26.055,0,30.001,22.563,30.001,22.563l3.89,20.986c3.744,0,2.264,5.341,0.289,9.992l-2.115,4.983 c-0.649,1.53-2.321,2.045-3.865,1.964l-6.571-0.344c-2.552-0.135-7.379-0.795-9.718-1.207l-38.247-6.744 C265.748,186.053,263.274,179.661,263.274,171.851L263.274,171.851z"
    />
    {/*Hightlight Base*/}
    <path 
        fill="rgb(65,65,65)" 
        d="M295.307,143.473c13.824,0.374,25.621,8.289,28.715,21.338	l3.996,21.561l1.332,0.235l0.078,0.425c2.385,0.355-0.638,7.259-1.067,8.282l-2.103,4.952c-0.514,1.059-1.612,1.277-2.701,1.248	l-6.552-0.344c-1.833-0.109-3.734-0.318-5.565-0.569l2.025-4.762c0.626-1.493,4.915-11.167,1.597-11.751l-0.694-0.123l-3.55-19.154 c-0.264-1.425-2.542-15.416-16.416-21.3C294.689,143.494,294.986,143.48,295.307,143.473L295.307,143.473z"
    /> 
    {/*Highlight*/}
    <path 
        fill="rgb(110,110,110)" 
        d="M295.307,143.473c13.824,0.374,25.621,8.289,28.715,21.338	l3.996,21.561l1.332,0.235l0.078,0.425c2.385,0.355-0.638,7.259-1.067,8.282l-2.103,4.952c-0.514,1.059-1.612,1.277-2.701,1.248	l-4.869-0.256l1.96-4.615c0.656-1.563,5.192-10.655,1.716-11.268l-0.137-0.024l-3.807-20.54 c-0.938-5.063-4.646-17.723-23.346-21.332C295.15,143.477,295.227,143.475,295.307,143.473L295.307,143.473z"
    />
    {/*Shadow Shape*/}
    <path 
        fill="rgb(110,110,110)" 
        d="M301.271,198.808l-30.487-5.376 c-2.691-7.023-6.208-13.934-6.284-21.573c0.185-7.932,3.001-14.31,7.501-18.997c-1.001,7.713-5.249,16.844,6.48,40.427 l23.384,4.121L301.271,198.808L301.271,198.808z"
    />
    {/*Roof Double Shadow*/}
    <path 
        fill="rgb(55,55,55)" 
        d="M272.619,193.756l-1.836-0.324 c-2.691-7.023-6.208-13.934-6.284-21.573c0.185-7.932,3.001-14.31,7.501-18.997c-0.882,6.794-4.281,14.691,2.94,32.598	L272.619,193.756L272.619,193.756z"
    />

    {/*Yellow Stripe*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M303.072,180.5c-1.008-1.035-1.926-2.146-2.775-3.32 c-12.211,0-24.422,0-36.634,0c0.163,1.117,0.374,2.22,0.628,3.32C277.218,180.5,290.146,180.5,303.072,180.5L303.072,180.5z"
    />
    {/*Yellow Stripe 1*/}
    <path 
        fill="rgb(250,165,25)" 
        d="M277.283,177.18c-2.14,0-11.48,0-13.62,0 c0.163,1.117,0.374,2.22,0.628,3.32c1.621,0,10.442,0,12.063,0L277.283,177.18L277.283,177.18z"
    />
    {/*Yellow Stripe 2*/}
    <path 
        fill="rgb(255,200,0)" 
        d="M272.121,177.18c-2.496,0-5.269,0-7.044,0	c0.224,1.118,0.504,2.224,0.825,3.32c1.896,0,4.881,0,7.217,0C272.74,179.347,272.408,178.241,272.121,177.18L272.121,177.18z"
    />

    {/*Blue Stripe*/}
    <path 
        fill="rgb(0,80,160)" 
        d="M296.924,171.56c-0.519-1.031-1.011-2.073-1.488-3.124	c-0.03-0.066-0.06-0.132-0.088-0.197c-10.604,0-21.206,0-31.809,0c-0.162,1.145-0.248,2.258-0.261,3.321 C274.493,171.56,285.709,171.56,296.924,171.56L296.924,171.56z"
    />
    {/*Blue Stripe 1*/}
    <path 
        fill="rgb(0,45,110)" 
        d="M279.784,168.238c-3.015,0-13.231,0-16.245,0 c-0.162,1.145-0.248,2.258-0.261,3.321c2.792,0,12.785,0,15.577,0L279.784,168.238L279.784,168.238z"
    />
    {/*Blue Stripe 2*/}
    <path 
        fill="rgb(30,65,155)" 
        d="M270.533,168.238c-2.187,0-4.282,0-5.756,0 c-0.143,1.074-0.233,2.182-0.27,3.321c1.605,0,3.998,0,6.407,0C270.734,170.393,270.611,169.287,270.533,168.238L270.533,168.238z"
    />

    {/*Red Stripe*/}
    <path 
        fill="rgb(175,0,0)" 
        d="M294.593,162.618c0.227-0.962,0.68-1.89,1.415-2.749 c0.216-0.211,0.434-0.4,0.654-0.572c-10.132,0-20.265,0-30.396,0c-0.528,1.102-0.981,2.212-1.364,3.321 C274.799,162.618,284.695,162.618,294.593,162.618L294.593,162.618z M323.402,162.618c-0.377-1.153-0.824-2.261-1.339-3.321 c-5.828,0-11.656,0-17.484,0l4.605,2.822c0.313,0.181,0.637,0.348,0.972,0.499C314.571,162.618,318.987,162.618,323.402,162.618 L323.402,162.618z"
    />
    {/*Red Stripe 1*/}
    <path 
        fill="rgb(120,0,0)" 
        d="M282.285,159.297c-2.939,0-13.08,0-16.02,0 c-0.528,1.102-0.981,2.212-1.364,3.321c3.085,0,13.37,0,16.454,0L282.285,159.297L282.285,159.297z"
    />
    {/*Red Stripe 2*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M323.402,162.618L323.402,162.618	c-0.046-0.143-0.094-0.284-0.143-0.424c0-0.002-0.001-0.005-0.002-0.007c-0.006-0.018-0.012-0.034-0.019-0.053 c-0.006-0.018-0.013-0.035-0.019-0.053c-0.057-0.16-0.113-0.319-0.173-0.479c-0.007-0.018-0.013-0.035-0.02-0.053 c-0.282-0.756-0.597-1.49-0.94-2.203c-0.008-0.018-0.016-0.034-0.024-0.051c-4.261,0-8.522,0-12.783,0
		c0.485,1.271,0.824,2.407,1.061,3.321C314.695,162.618,319.049,162.618,323.402,162.618L323.402,162.618z"
    />
    {/*Red Stripe 3*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M323.402,162.618L323.402,162.618	c-0.046-0.143-0.094-0.284-0.143-0.424c0-0.002-0.001-0.005-0.002-0.007c-0.006-0.018-0.012-0.034-0.019-0.053 c-0.006-0.018-0.013-0.035-0.019-0.053c-0.057-0.16-0.113-0.319-0.173-0.479c-0.007-0.018-0.013-0.035-0.02-0.053 c-0.282-0.756-0.597-1.49-0.94-2.203c-0.008-0.018-0.016-0.034-0.024-0.051c-1.762,0-3.522,0-5.284,0
		c0.504,1.194,0.871,2.319,1.143,3.321C319.75,162.618,321.576,162.618,323.402,162.618L323.402,162.618z"
    />
    {/*Red Stripe 4*/}
    <path 
        fill="rgb(170,0,0)" 
        d="M270.914,159.297c-1.314,0-2.512,0-3.447,0 c-0.527,1.057-0.99,2.164-1.385,3.321c1.173,0,2.746,0,4.452,0C270.622,161.438,270.758,160.338,270.914,159.297L270.914,159.297z"
    />

    {/*Visor Black Background*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M296.008,159.869c1.348-1.318,2.801-1.846,4.589-1.877	c1.384,0.087,2.493,0.447,3.72,1.144l4.868,2.983c1.511,0.874,3.318,1.426,5.068,1.468h10.462c2.343,0.171,3.435,1.169,3.916,3.433 l3.176,17.135c0.246,1.495-0.053,2.72-1.793,2.867h-3.879c-1.25-0.016-2.475-0.183-3.704-0.393l-15.239-2.687 c-4.283-2.877-7.226-6.723-9.666-11.216c-0.744-1.408-1.431-2.842-2.09-4.291C294.135,165.568,293.826,162.416,296.008,159.869	L296.008,159.869z"
    />
    {/*Visor Color Base*/}
    <path 
        fill="rgb(0,60,130)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M296.365,167.523c-2.801-6.212,2.553-10.267,7.328-7.334 l4.865,2.981c1.674,1.025,4.138,1.64,5.68,1.64h10.432c2.082,0,2.518,1.143,2.76,2.447l3.171,17.107 c0.182,0.979,0.125,1.432-0.638,1.432l-5.182,0.004l-17.122-3.02C301.553,178.843,298.28,171.768,296.365,167.523L296.365,167.523z M301.424,160.654c-2.267,0-4.115,1.849-4.115,4.115s1.849,4.115,4.115,4.115c2.268,0,4.115-1.849,4.115-4.115 S303.691,160.654,301.424,160.654L301.424,160.654z"
    />
    {/*Visor Highlight Base*/}
    <path 
        fill="rgb(0,125,200)" 
        d="M324.67,164.811h-10.432h-0.102l3.662,19.76l6.982,1.23 l4.418-0.003l-3.882-20.944C325.121,164.825,324.906,164.811,324.67,164.811L324.67,164.811z"
    />
    {/*Visor Hightlight*/}
    <polygon 
        fill="rgb(0,175,240)" 
        points="318.42,164.811 324.021,164.811 327.912,185.797 324.762,185.797 322.227,185.351 318.42,164.811 	"
    />
    {/*Visor Rivet*/}
    <path 
        fill="rgb(150,150,150)" 
        d="M301.424,161.135c2.002,0,3.636,1.633,3.636,3.635	s-1.634,3.635-3.636,3.635s-3.635-1.633-3.635-3.635S299.422,161.135,301.424,161.135L301.424,161.135z M301.424,162.477 c-1.263,0-2.293,1.03-2.293,2.293c0,1.264,1.03,2.294,2.293,2.294c1.264,0,2.294-1.03,2.294-2.294	C303.718,163.507,302.688,162.477,301.424,162.477L301.424,162.477z"
    /> 
    {/*Visor Slot*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M309.85,166.428c0-0.748-0.611-1.359-1.36-1.359s-1.36,0.611-1.36,1.359 c0,0.313,0.11,0.599,0.289,0.829c-0.572,1.412-1.606,2.598-2.961,3.249c-1.514,0.68-0.701,2.139,0.471,1.58 c1.85-0.891,3.301-2.468,4.05-4.392C309.486,167.497,309.85,167.005,309.85,166.428z"
    />
    {/*Suit*/}
    <polygon 
        fill="rgb(255,245,0)" 
        points="363.313,198.04 353.853,201.166 364.894,201.938 363.313,198.04 	"
    />
    

    

		</svg>
		</div>

	);//return
}